import React, {Component} from 'react';
import styled from 'styled-components';
import Parser from "html-react-parser";
import {media, mixins} from "../../mixins";
import H from "../typography/H";

const Title = styled.div`
  margin-bottom: 20px;
  color: ${p => p.theme.cTheme};
  text-align: center;
`;
const Text = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const Feature = styled.div`
  text-align: center;
`;
const FeatureIcon = styled.div`
  text-align: center;
  font-size: ${p => p.theme.sIconBig}px;
  color: ${p => p.theme.cTheme};
  margin-bottom: 15px;
  i{
    display: block;
  }
`;
const FeatureTitle = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;
const FeatureText = styled.div`
  text-align: center;
`;

class FeaturesBlock extends Component {
    render() {

        const block = this.props.block;
        const features = this.props.block.features ? this.props.block.features.map((feature, key) => {
            return <Feature key={key} className={'col-lg-3'}>
                <FeatureIcon><i className={'icon-' + feature.icon}/></FeatureIcon>
                <FeatureTitle>
                    <H size={3} styleSize={4}>{feature.title}</H>
                </FeatureTitle>
                <FeatureText>{feature.text}</FeatureText>
            </Feature>
        }) : '';

        return (
            <section className={this.props.className}>
                <div className={'container'}>
                    <div className={'row justify-content-center'}>
                        <div className={'col-md-8'}>
                            <Title>
                                <H size={2} styleSize={2}>{block.title}</H>
                            </Title>
                            <Text>
                                {Parser(block.text)}
                            </Text>
                        </div>
                    </div>
                    <div className={'row justify-content-center'}>
                        {features}
                    </div>
                </div>
            </section>
        );
    }
}

export default styled(FeaturesBlock)`
  padding-bottom: 80px;
`;
